import { render, staticRenderFns } from "./dm-detail-luk.vue?vue&type=template&id=40acc290&scoped=true"
import script from "./dm-detail-luk.vue?vue&type=script&lang=js"
export * from "./dm-detail-luk.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-luk.vue?vue&type=style&index=0&id=40acc290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acc290",
  null
  
)

export default component.exports